import { Provider } from '@angular/core';

import { KioskCategoryPagePreviewDataSource } from './kiosk-category-page-preview-data-source';

export function provideKioskCategoryPagePreviewDataSource(): Provider[] {
  return [KioskCategoryPagePreviewDataSource];
}
